import {sendQuotaInstructionsEmail} from '@account/api';
import {trackEvent} from '@account/analytics';
import {useMutation} from '@tanstack/react-query';
import {useState} from 'react';

// Sends the customer-facing allocation-instructions email for a CA. Mirrors
// useSendPasswordResetEmail: a custom error state so the caller can clear it
// (e.g. when the user edits the recipient and retries).
export const useSendQuotaInstructionsEmail = () => {
  const [mutationError, setMutationError] = useState(null);

  const {mutate, data, isLoading} = useMutation({
    mutationFn: sendQuotaInstructionsEmail,
    onError: error => {
      trackEvent(`Send quota instructions email error: ${error?.message}`);
      setMutationError(error);
    },
    onSuccess: () => {
      setMutationError(null);
    },
  });

  return {
    data,
    error: mutationError,
    isLoading,
    mutate,
    setError: setMutationError,
  };
};

export default useSendQuotaInstructionsEmail;
